import * as RSUJOBInstrumentStatusConstant from './RSUJOBInstrumentStatusConstant.js';

// Object.assign is not yet fully supported in all browsers, so we fallback to
// a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
    isJobStatusFetching: false,
    isJobStatusFetched: false,
    isJobStatusFetchFailed: false,
    rsuJobStatusList:[],
    isWorkOrderStatusFetching: false,
    isWorkOrderStatusFetched: false,
    isWorkOrderStatusFetchFailed: false,
    workOrderStatus:{}
};

export default function RSUJOBStatusReducer(state = initialState, action) {

    const getUpdatedRSUViewList = (isDisabled) => {
        let viewList = JSON.parse(JSON.stringify(state.rsuJobStatusList))
        let findWorkOrderObj = viewList.find(elem => elem.workOrderId == action.workOrderId)
        findWorkOrderObj.isButtonDisabled = isDisabled;
        return viewList;
    }

    const getStatusUpdatedRSUViewList = (workOrderStatus, workOrderId) => {
        let viewList = JSON.parse(JSON.stringify(state.rsuJobStatusList))
        let findWorkOrderObj = viewList.find(elem => elem.workOrderId == workOrderId)
        findWorkOrderObj.workOrderStatus = workOrderStatus;
        findWorkOrderObj.isButtonDisabled = false;
        return viewList;
    }


    switch(action.type){

        case RSUJOBInstrumentStatusConstant.GET_RSU_INSTR_JOB_LIST:
                return assign({}, state, {
                    isJobStatusFetching: true,
                    isJobStatusFetched: false,
                    isJobStatusFetchFailed: false,
                });
            break;
        case RSUJOBInstrumentStatusConstant.GET_RSU_INSTR_STS_SUCCESS:
            console.log("JOB Status for RSU is >>> ",action.newState.result);
                return assign({}, state, {
                    isJobStatusFetching: false,
                    isJobStatusFetched: true,
                    isJobStatusFetchFailed: false,
                    rsuJobStatusList: action.newState.result
                });
            break;
        case RSUJOBInstrumentStatusConstant.GET_RSU_INSTR_STS_FAILURE:
                return assign({}, state, {
                    isJobStatusFetching: false,
                    isJobStatusFetched: false,
                    isJobStatusFetchFailed: true,
                });
                break;   
        case RSUJOBInstrumentStatusConstant.GET_WORK_ORDER_STATUS:
                return assign({}, state, {
                    isWorkOrderStatusFetching: true,
                    isWorkOrderStatusFetched: false,
                    isWorkOrderStatusFetchFailed: false,
                    rsuJobStatusList: getUpdatedRSUViewList(true)
                });
                break;
        case RSUJOBInstrumentStatusConstant.GET_WORK_ORDER_STATUS_SUCCESS:
                return assign({}, state, {
                    isWorkOrderStatusFetching: false,
                    isWorkOrderStatusFetched: true,
                    isWorkOrderStatusFetchFailed: false,
                    rsuJobStatusList: getStatusUpdatedRSUViewList(action.newState.status, action.newState.workOrderId)
        });
        break;  
        case RSUJOBInstrumentStatusConstant.GET_WORK_ORDER_STATUS_FAILURE:
                return assign({}, state, {
                    isWorkOrderStatusFetching: false,
                    isWorkOrderStatusFetched: false,
                    isWorkOrderStatusFetchFailed: true,
                    rsuJobStatusList: getUpdatedRSUViewList(false)
        });
        break;       
        default:
            return state;

    }

}